// El recuadro que explica por qué un video adjunto no sirve (o sirve con reparos) como
// referencia para generar un video —
// ADR-2026-10-20-el-video-de-referencia-se-ajusta-a-lo-que-acepta-seedance.
//
// Sale de los adjuntos que hay puestos, no de un evento de subida: lo dibuja igual la caja
// del chat que la de Crear, venga el video de "Subir archivo", de pegarlo o de soltarlo, y
// se va solo al quitarlo. Las medidas las guarda `prepararAdjunto`; un video sin medidas
// (uno generado por Atlas) no avisa nada.

import { AlertCircle, Info } from 'lucide-react';
import type { ChatAttachment } from '../../pages/v2/agentAttachments';
import { avisoDeVideoDeReferencia } from '../../utils/videoDeReferencia';

export function avisosDeVideos(adjuntos: readonly ChatAttachment[]) {
  return adjuntos.flatMap((a) => {
    if (a.kind !== 'video') return [];
    const aviso = avisoDeVideoDeReferencia(a);
    return aviso ? [{ id: a.id, nombre: a.name, ...aviso }] : [];
  });
}

export const AvisosDeVideos: React.FC<{ adjuntos: readonly ChatAttachment[]; className?: string }> = ({
  adjuntos,
  className = '',
}) => {
  const avisos = avisosDeVideos(adjuntos);
  if (avisos.length === 0) return null;
  return (
    <div className={`flex flex-col gap-1.5 ${className}`}>
      {avisos.map((a) => {
        const Icono = a.grave ? AlertCircle : Info;
        return (
          <div
            key={a.id}
            role="status"
            className={`flex items-start gap-2 rounded-xl px-3 py-2 text-[12.5px] leading-snug ${
              a.grave ? 'bg-[#FDEEEE] text-[#9E2B26]' : 'bg-[#F2F4F9] text-[#02062B]/[0.7]'
            }`}
          >
            <Icono className="mt-px h-3.5 w-3.5 shrink-0" strokeWidth={2.25} aria-hidden="true" />
            <span className="min-w-0">
              {avisos.length > 1 && <span className="font-medium">{a.nombre}: </span>}
              {a.texto}
            </span>
          </div>
        );
      })}
    </div>
  );
};
